import {Card} from '@/components/card';
import {LoadMoreButton} from '@/components/load-more-button';
import {Event} from './event';
import styles from './events-list.module.scss';

export const EventsList = ({
  entity,
  events,
  loading,
  isLoadMoreButtonVisible,
  onLoadMoreButtonClick,
}) => (
  <Card title="Events">
    <div className={styles.container} key={`div_${entity}`}>
      {events.map((event, index) => (
        <Event key={event.id || index} event={event} entity={entity} />
      ))}
      {isLoadMoreButtonVisible && (
        <LoadMoreButton loading={loading} onClick={onLoadMoreButtonClick} />
      )}
    </div>
  </Card>
);
